<!----
    Author: hjlee
    Description:
        이미지 슬라이더 컨트롤
---->
<template>
  <div class="image-slider3d" :image-count="contents?contents.length:0">
    <carousel-3d :controls-visible="true">
      <slide
        v-for="(file, fileIndex) in contents"
        :key="fileIndex"
        :index="fileIndex"
      >
        <template slot-scope="{ complete, isCurrent, leftIndex, rightIndex }">
          <div v-if="usePrimary && file.primaryFlag === 'Y'" class="thumb-primary-icon">
            <i class="fa fa-star" aria-hidden="true" />
          </div>
          <centered-image :index="complete" :class="{ current: isCurrent, onLeft: (leftIndex >= 0), onRight: (rightIndex >= 0) }" :src="getImgUrl(file, width, undefined, true)" :alt="file.fileNm" @click="clickImage" />
        </template>
      </slide>
    </carousel-3d>
    <image-viewer v-if="selectedImageSrc" ref="imageViewerRef" :src="selectedImageSrc" :alt="selectedImageName" />
  </div>
</template>

<script>
export default {
  props: {
    usePrimary: {
      type: Boolean,
      default: false
    },
    contents: {
      type: Array,
      required: true
    },
    width: {
      type: Number,
      default: 500
    }
  },
  data: function() {
    return {
      selectedImageSrc: undefined,
      selectedImageName: undefined
    }
  },
  methods: {
    clickImage(e) {
      if ($(e.target).hasClass('current')) {
        this.selectedImageSrc = $(e.target).attr('src')
        this.selectedImageName = $(e.target).attr('alt')
        this.$nextTick(() => {
          this.showImageViewer()
        })
      }
    },
    showImageViewer() {
      this.$refs.imageViewerRef.showImageViewer()
    }
  }
}
</script>

<style scoped>
>>> .carousel-3d-controls {
  opacity: 1;
}
>>> .carousel-3d-controls a:focus,
>>> .carousel-3d-controls a:hover,
>>> .carousel-3d-controls a:active {
  outline: none !important;
  box-shadow: none !important;
}
>>> .carousel-3d-controls a span {
  font-family: 'NanumSquareRoundB';
}
>>> .carousel-3d-slide {
  border: none !important;
  background: white !important;
  opacity: 0 !important;
}
>>> .carousel-3d-slide.current {
  opacity: 1 !important;
}
.thumb-primary-icon {
  position: absolute;
  margin-left: 5px;
}
</style>
